<template>
  <div class="photo-block" :class="{'photo-block--without-container': withoutContainer}">
    <header class="photo-block__header">
      <h3 class="photo-block__title">{{ title }}</h3>
    </header>
    <picture class="photo-block__image">
      <source :srcset="srcSet[`image_mobile_${language}_src`]" media="(max-width: 768px)" />
      <source :srcset="srcSet[`image_desktop_${language}_src`]" />
      <img :src="srcSet[`image_${language}_src`]" :alt="alt" />
    </picture>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'PhotoBlock',
  props: {
    alt: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    srcSet: {
      type: Object,
      default: () => ({})
    },
    withoutContainer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation.language
    }),
    imgPlaceholder () {
      return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1920 400'%3E%3C/svg%3E"
    }
  }
}
</script>

<style scoped lang="sass">
.photo-block
  padding: 0 15px

  &--without-container
    padding: 0

    +mmin($tablet--hor)
      padding: 0 15px

.photo-block__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 30px

.photo-block__title
  font-size: 24px
  font-weight: 500
  padding: 0
  margin: 0
</style>
